import React from "react";
import {Link} from "gatsby";
// @ts-ignore
import sitemap from "../data/sitemap.json";
// @ts-ignore
import logo from "../images/logo-light.png";

export default () => (
	<footer className="container-fluid px-0">
		<div className="container">
			<div className="row">
				<div className="col-12 col-md-3 logo">
					<img src={logo} alt=""/>
				</div>
				<div className="col-12 col-md-9">
					<div className="row">
						<div className="footer-item col-12 col-md-3 pt-5 pt-md-0">
							<h4>ABOUT US</h4>
							<ul>
								<li>
									<Link to={sitemap.index}>Main</Link>
								</li>
								<li>
									<a href="http://sono.com.tr/en/about.html">About Us</a>
								</li>
								<li>
									<Link to={sitemap.leaflets}>Leaflets</Link>
								</li>
								<li>
									<a href="http://sono.com.tr/en/contact.html">Contact</a>
								</li>
								<li>
									<Link to={sitemap.demo}>Demo Request</Link>
								</li>
							</ul>
						</div>
						<div className="footer-item col-12 col-md-3 pt-5 pt-md-0">
							<h4>FROM US</h4>
							<ul>
								<li>
									<a href="https://blog.sono.com.tr">KYS Blog</a>
								</li>
								<li>
									<a href="https://www.niyeo.com">Niyeo</a>
								</li>
								<li>
									<a href="http://www.internetmagazaciligi.com">Internet Store</a>
								</li>
								<li>
									<a href="http://blog.niyeo.com">Niyeo Blog</a>
								</li>
							</ul>
						</div>
						<div className="footer-item col-12 col-md-3 pt-5 pt-md-0">
							<h4>AGREEMENTS</h4>
							<ul>
								<li>
									<Link to={sitemap.terms}>Terms and Conditions</Link>
								</li>
								<li>
									<Link to={sitemap.privacyPolicy}>Website privacy policy</Link>
								</li>
								<li>
									<Link to={sitemap.websiteTerms}>Website Terms and Conditions </Link>
								</li>
							</ul>
						</div>
						<div className="footer-item col-12 col-md-3 pt-5 pt-md-0">
							<h4>SOCIAL</h4>
							<ul>
								<li>
									<a href="https://www.linkedin.com/company/sono-yazilim-anonim-sirketi/">
										<i className="fab fa-linkedin-in"/>LinkedIn
									</a>
								</li>
								<li>
									<a href="https://twitter.com/sonoyazilim">
										<i className="fab fa-twitter"/>Twitter
									</a>
								</li>
								<li>
									<a href="#">
										<i className="fab fa-facebook-f"/>Facebook
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className="col-12 desc">
					Sono Software Corporation Ⓒ 2015 All rights reserved.
				</div>
			</div>
		</div>
	</footer>
)
